var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmOnBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3882_101035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.5C13 4.94772 13.4477 4.5 14 4.5C14.5523 4.5 15 4.94772 15 5.5V6.08719C16.1245 6.28486 17.1728 6.81333 17.9973 7.61771C19.0634 8.65779 19.6686 10.0756 19.6686 11.5613V16.6242C19.6686 16.9972 19.8202 17.362 20.1013 17.6362C20.4086 17.936 20.6757 18.0711 21.0558 18.0711C21.3011 18.0711 21.5 18.2791 21.5 18.5356C21.5 18.7921 21.3011 19 21.0558 19H6.94423C6.69889 19 6.5 18.7921 6.5 18.5356C6.5 18.2791 6.69889 18.0711 6.94423 18.0711C7.32426 18.0711 7.59131 17.936 7.89867 17.6362C8.17975 17.362 8.33133 16.9972 8.33133 16.6242V11.5613C8.33133 10.0756 8.93659 8.65779 10.0027 7.61771C10.8272 6.81332 11.8755 6.28485 13 6.08718V5.5ZM12.5 20.75C12.0858 20.75 11.75 21.0858 11.75 21.5C11.75 21.9142 12.0858 22.25 12.5 22.25H15.5C15.9142 22.25 16.25 21.9142 16.25 21.5C16.25 21.0858 15.9142 20.75 15.5 20.75H12.5Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3882_101035",
    x: 5.5,
    y: 4.5,
    width: 17,
    height: 19.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3882_101035"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3882_101035",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmOnBlack);
export default __webpack_public_path__ + "static/media/ic-alarm-on-black.2ec55a02dfe5d7cb47480148c2142eb5.svg";
export { ForwardRef as ReactComponent };